export const APP_STORE_URL =
  "https://apps.apple.com/us/app/careem-rides-food-delivery/id592978487";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.careem.acma&hl=en&gl=US";
export const CAREEM_APP_URL = "careem://open";
export const ANALYTICKA_EVENT_NO_INVOICE_ID = "no_invoice_id_provided";
export const HELP_CENTER_LINK = {
  CODE_VERIFICATION:
    "https://help.careem.com/hc/en-us/articles/360001609587-What-if-I-didn-t-receive-a-verification-code-",
  CREATE_ACCOUNT:
    "https://help.careem.com/hc/en-us/articles/360001609507-Creating-an-account",
  FORGET_PASSWORD:
    "https://help.careem.com/hc/en-us/articles/360001592468-I-forgot-my-password",
};

export const BLOCKED_LINK = "https://help.careem.com/hc/en-us/requests/new";

export const ANALYTIKA_EVENTS = {
  PAGE: {
    BLOCKED_USER: "blocked_user",
    WELCOME_BACK_IS_IT_YOU: "welcome_back_isityou",
    PASSWORD: "password",
    WELCOME: "welcome",
    OTP_VERIFY: "otp_verify",
    BUSINESS_INVITATION: "business_invitation",
    FORGOT_PASSWORD: "forgot_password",
    SIGNUP_FORM: "signup_form",
    VERIFY__CARD_FORM_VIEW: "verify__card_challenge",
    VERIFY_EMAIL_FORM_VIEW: "verify_email_challenge",
    VERIFY_FULL_NAME_FORM_VIEW: "verify_full_name_challenge",
    VERIFY_PIN_FORM_VIEW: "verify_pin_challenge",
  },
  IDNW_BUSINESS_INVITATION_SUBMIT: {
    event_name: "idnw_business_invitation_submit",
    event_version: 5,
    signature: "",
  },
  IDNW_BUSINESS_INVITATION_RESULT: {
    event_name: "idnw_business_invitation_result",
    event_version: 5,
    signature: "",
  },
  IDNW_ENTER_PHONE_NUMBER: {
    event_name: "idnw_enter_phone_number",
    event_version: 15,
    signature: "AQ8BEiB8AAAAAAAAAK3zJaULk5mHIFvKSbrDhQU3AAATtwHRmrs",
  },
  IDNW_TAP_BUTTON: {
    event_name: "idnw_tap_button",
    event_version: 14,
    signature: "AQ4BFiicAAAAAAAAANNbqMu6omoQgzzXI-npd2Et11BKyzA1jzUAAAAAAABRPQ",
  },
  IDNW_TAP_OPTION: {
    event_name: "idnw_tap_option",
    event_version: 14,
    signature: "AQ4BEyB8AAAAAAAAALdK4LFvb4bTPqcCEqb7FuV9ABQqK9oP7BA",
  },
  IDNW_SELECT_LANGUAGE: {
    event_name: "idnw_select_language",
    event_version: 12,
    signature: "AQwBESB8AAAAAAAAAKPC2OwJC72HWuBQ4DUHoLP_AAAABWbzXug",
  },
  IDNW_SELECT_COUNTRY: {
    event_name: "idnw_select_country",
    event_version: 13,
    signature: "AQ0BESB8AAAAAAAAAKPC2OwJC72HWuBQ4DUHoLP_AAAABWbzXug",
  },
  IDNW_VIEW_PAGE: {
    event_name: "idnw_view_page",
    event_version: 14,
    signature: "AQ4BFiicAAAAAAAAANNbjIqqsmoQkzz39-ntZ2ER11Ba2TA3rxUAAAAAAAQXtQ",
  },
  IDNW_ENTER_PASSWORD: {
    event_name: "idnw_enter_password",
    event_version: 13,
    signature: "AQ0BEyB8AAAAAAAAALdK4LMub4bTP6cCGqb7FuV9AFQqK9oO7BE",
  },
  IDNW_SEND_WEBREQUEST: {
    event_name: "idnw_send_webrequest",
    event_version: 15,
    signature: "AQ8BFCB8AAAAAAAAAMD4nuOwdxw6Ss6c8Avut6izULPjqOEZg7I",
  },
  IDNW_SUCCESS_LOGIN: {
    event_name: "idnw_success_login",
    event_version: 20,
    signature: "ARQBFSicAAAAAAAAAMrbqyY_OIfz-KsNKY7eyie56QOKyuIkv4AAAAAAAAAA4A",
  },
  IDNW_ENTER_OTP: {
    event_name: "idnw_enter_otp",
    event_version: 18,
    signature: "ARIBHDC8AAAAAAAAAQ0UJitz1culYOHJTn0Ron2E53z6f7lgWXWV7xr8CHkGYgAAAAAAABR9",
  },
  IDNW_ENTER_NAME: {
    event_name: "idnw_enter_name",
    event_version: 15,
    signature: "AQ8BEyB8AAAAAAAAALdK4LMuZ4bbP6cCGqb7FuV9AFQqK8oO_Dk",
  },
  IDNW_SUCCESS_SIGNUP: {
    event_name: "idnw_success_signup",
    event_version: 20,
    signature: "ARQBFSicAAAAAAAAAMrbqyY_OIfz-KsNKY7eyie56QOKyuIkv4AAAAAAAAAA4A",
  },
};
